import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const CloseableMessage = ({ children, onClose }) => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="framed-message" style={{ position: "relative" }}>
      <button
        onClick={() => {
          setVisible(false);
          onClose?.();
        }}
        style={{
          position: "absolute",
          top: 6,
          right: 0,
          background: "none",
          border: "none",
          fontSize: 18,
          color: "#2563eb",
          cursor: "pointer",
          fontWeight: 400,
        }}
        aria-label="Close"
      >
        <IoMdClose />
      </button>
      {children}
    </div>
  );
};

export default CloseableMessage;
